import React from "react";
import { hooks } from "../../hooks";
import { items } from "../../items";
import { components } from "../../components";

export const History: React.FC = () => {
  const { history, historyLoading } = hooks.useGetHistory({
    sort_by: "created_at",
    sort_type: "desc",
  });

  const groupedHistory = history.reduce((acc, item) => {
    const key = `${item.date}-${item.patrolName}`;
    
    if (!acc[key]) {
      acc[key] = {
        date: item.date,
        patrolName: item.patrolName,
        day: item.day,
        groupName: item.groupName,
        items: [],
        totalSpots: 0,
        completedSpots: 0
      };
    }
    
    acc[key].items.push(item);
    acc[key].totalSpots += item.totalSpots;
    acc[key].completedSpots += item.completedSpots;
    
    return acc;
  }, {} as Record<string, any>);

  const groupedHistoryArray = Object.values(groupedHistory);

  return (
    <div id="screen" style={{opacity:1}}>
      <main className="scrollable container">
        {historyLoading ? (
              <div style={{ padding: 20, textAlign: 'center' }}>
                <components.Loader />
              </div>
            ) : history.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
                <p className="t14">Belum ada riwayat patroli</p>
                <p className="t12" style={{ opacity: 0.7 }}>
                  Selesaikan patrol pertama mu untuk melihat riwayatmu disini
                </p>
              </div>
            ) : (
          <ul
            className="history-list"
            style={{
              display: "grid",
              gap: 15,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            {groupedHistoryArray.map((group, index) => (
              <items.HistoryItem
                key={`${group.date}-${group.patrolName}`}
                index={index}
                history={{

                  id: `${group.date}-${group.patrolName}`,
                  patrolName: group.patrolName,
                  date: group.date,
                  day: group.day,
                  groupName: group.groupName,
                  spotDetails: group.items.flatMap((item: any) => item.spotDetails),
                  totalSpots: group.totalSpots,
                  completedSpots: group.completedSpots,
                  status: group.items.every((item: any) => item.status === 'done') ? 'done' : 'pending',
                  clockIn: group.items[0]?.clockIn || '',
                  patrol_route_id: group.items.map((item: any) => item.patrol_route_id).join(','),
                  rawDate: group.items[0]?.rawDate || '',
                }}
                isLast={index === groupedHistoryArray.length - 1}
              />
            ))}
          </ul>
        )}
      </main>
    </div>
  );
};